package ru.chm.gradereport.ui.screens.reviewers

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import ru.chm.gradereport.ui.theme.GradeTheme
import androidx.compose.ui.unit.dp
import ru.chm.gradereport.ui.components.AppCard
import ru.chm.gradereport.ui.components.AppTextField
import ru.chm.gradereport.ui.components.PrimaryButton

@Composable
internal fun CreateReviewerCard(
    displayName: String,
    onDisplayNameChange: (String) -> Unit,
    login: String,
    onLoginChange: (String) -> Unit,
    password: String,
    onPasswordChange: (String) -> Unit,
    onCreate: () -> Unit,
) {
    AppCard(modifier = Modifier.fillMaxWidth().padding(vertical = 16.dp)) {
        Text("Новый проверяющий", color = GradeTheme.colors.textPrimary, fontWeight = FontWeight.SemiBold)
        AppTextField(displayName, onDisplayNameChange, "ФИО", modifier = Modifier.padding(top = 8.dp))
        AppTextField(login, onLoginChange, "Логин", modifier = Modifier.padding(top = 8.dp))
        AppTextField(password, onPasswordChange, "Пароль", modifier = Modifier.padding(top = 8.dp))
        PrimaryButton(
            "Создать",
            enabled = login.isNotBlank() && password.isNotBlank(),
            onClick = onCreate,
            modifier = Modifier.padding(top = 12.dp),
        )
    }
}
